/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_anagrams_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anagrams (uses all letters)`)
};

const es_wu_anagrams_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anagramas (usa todas las letras)`)
};

const de_wu_anagrams_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anagramme (verwendet alle Buchstaben)`)
};

const nl_wu_anagrams_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anagrammen (gebruikt alle letters)`)
};

const fr_wu_anagrams_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anagrammes (utilise toutes les lettres)`)
};

const it_wu_anagrams_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anagrammi (usa tutte le lettere)`)
};

const pt_br2_wu_anagrams_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anagramas (usa todas as letras)`)
};

const pt_wu_anagrams_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anagramas (utiliza todas as letras)`)
};

const ja_wu_anagrams_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アナグラム（すべての文字を使用）`)
};

const zh_wu_anagrams_title = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`易位构词（使用全部字母）`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_anagrams_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_anagrams_title(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_anagrams_title", locale)
	if (locale === "en") return en_wu_anagrams_title(inputs)
	if (locale === "es") return es_wu_anagrams_title(inputs)
	if (locale === "de") return de_wu_anagrams_title(inputs)
	if (locale === "nl") return nl_wu_anagrams_title(inputs)
	if (locale === "fr") return fr_wu_anagrams_title(inputs)
	if (locale === "it") return it_wu_anagrams_title(inputs)
	if (locale === "pt-BR") return pt_br2_wu_anagrams_title(inputs)
	if (locale === "pt") return pt_wu_anagrams_title(inputs)
	if (locale === "ja") return ja_wu_anagrams_title(inputs)
	return zh_wu_anagrams_title(inputs)
};